<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="flex flex-wrap items-end">
                <div class="flex-grow">
                    <vs-button
                        @click="addPermission"
                        color="primary"
                        type="border"
                        icon-pack="feather"
                        icon="icon-plus">
                        {{ $t('button.addPermissions') }}
                    </vs-button>
                </div>
                <div class="vx-col md:w-2/12 w-full mt-2">
                    <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                              v-model="searchQuery"
                              @input="updateSearchQuery" placeholder="Tìm kiếm..."/>
                </div>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh"
                         ref="agGridTable"
                         class="ag-theme-material w-100 my-4 ag-grid-table"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="permissionsList"
                         :animateRows="true"
                         :localeText="{noRowsToShow: this.$t('menuCustomer.noRowsToShow')}"
                         paginationPageSize="50"
                         :pagination="true"
                         @pagination-changed="onPaginationChanged"
                         @grid-ready="onGridReady"
                         :autoSizeStrategy="autoSizeStrategy"
                         tooltipShowDelay="0"
                         tooltipHideDelay="5000">
            </ag-grid-vue>

            <div class="vx-row mt-8" v-if="totalElements > 0">
                <div style="min-width:200px" class="vx-col md:w-1/2 w-full">
                    <span class="content-page font-bold">{{ $t('dashboard.display') }}</span>
                    <span class="text-page">
                        {{ countElementPage > totalElements ? totalElements : countElementPage }} / {{ totalElements }}
                    </span>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                    <vs-pagination
                        :total="totalPages"
                        v-model="currentPage"
                        @change="loadPage"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import Pagination from "../../ui-elements/Pagination.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import CellRendererContent from "./cell-renderer/CellRendererContent";
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ModuleRegistry } from '@ag-grid-community/core';

// Register the required feature modules with the Grid
ModuleRegistry.registerModules([ClientSideRowModelModule]);

export default {
    components: {
        AgGridVue,

        // Cell Renderer
        Pagination,
        CellRendererActions,
        CellRendererContent
    },
    data() {
        return {
            searchQuery: "",
            // AgGrid
            gridApi: null,
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: 'ID',
                    field: 'id',
                    width: 80
                },
                {
                    headerName:  this.$t('root.functionName'),
                    field: 'functionName',
                    width: 150,
                    tooltipField: 'functionName',
                },
                {
                    headerName: 'Alias',
                    field: 'functionAlias',
                    width: 170
                },
                {
                    headerName: this.$t('liveStream.screen'),
                    field: 'groupPermission',
                    cellRenderer: 'CellRendererContent',
                    width: 200
                },
                {
                    headerName: this.$t('menuPackage.actions'),
                    field: 'actions',
                    width: 80,
                    cellRenderer: 'CellRendererActions',
                },
            ],
            permissionsList: [],
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            totalPages: 0,
            currentPage: 1,
            countElementPage: 0,
            totalElements: 0,
        }
    },
    created() {
        this.initScreen();
    },
    watch: {
        '$store.state.deleteNotification'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('DELETE_NOTIFY', false);
            }
        },
    },
    computed: {
    },
    methods: {
        addPermission() {
            this.$router.push('/user/add-permission').catch(() => {
            })
        },
        onGridReady(params) {
            this.gridApi = params.api;
        },
        initScreen() {
            this.$vs.loading();
            this.$oauth.get('/permission-function-global/find-all').then((response) => {
                this.permissionsList = response.data;
                this.countElementPage = this.currentPage * 20;
                this.totalElements = this.permissionsList.length;
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger',
                });
            });
        },
        updateSearchQuery(val) {
            this.gridApi.setGridOption('quickFilterText', val);
        },

        onPaginationChanged() {
            if (this.gridApi) {
                this.totalPages = this.gridApi.paginationGetTotalPages();
            }
        },
        loadPage: function (currentPage) {
            if (this.gridApi) this.gridApi.paginationGoToPage(currentPage - 1)
        },
    },
}
</script>

<style lang="scss">
.ag-paging-panel {
    display: none;
}
</style>
